import { List, Datagrid, TextField, NumberField, FunctionField, TextInput } from "react-admin";
import { CopyableId } from "../../components/CopyableId";

const filters = [
  <TextInput key="roundId" source="roundId" label="Round ID" alwaysOn />,
  <TextInput key="userId" source="userId" label="User ID" alwaysOn />,
];

export const WalletRequestList = () => (
  <List filters={filters} perPage={25}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="action" label="Action" />
      <TextField source="actionType" label="Type" />
      <NumberField source="amount" label="Amount" options={{ minimumFractionDigits: 2 }} />
      <TextField source="currency" label="Cur" />
      <FunctionField label="Tx ID" render={(r: { transactionId?: string }) => <CopyableId value={r?.transactionId} />} />
      <FunctionField label="Round ID" render={(r: { roundId?: string }) => <CopyableId value={r?.roundId} />} />
      <FunctionField label="User ID" render={(r: { userId?: string }) => <CopyableId value={r?.userId} />} />
      <TextField source="status" label="Status" />
      <NumberField source="resultCode" label="Code" />
    </Datagrid>
  </List>
);
